
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import style from '../../styles/content.module.css'
import formStyle from '../../styles/form.module.css'

import { getLayout, LayoutContext } from '../../components/sg/Layout'
import Header from '../../components/Header'
import Loading from '../../components/Loading'
import useTranslation from 'next-translate/useTranslation'
import classNames from 'classnames/bind'
import { useRef, useState, useContext } from 'react'
import Image from 'next/image'
import Footer from '../../components/sg/Footer'
import Cards from '../../components/sg/Cards'
import Head from 'next/head'
import useUser from '../../hooks/useUser'
import { event } from '../../helpers/analytics'

export default function Contact () {
  const { t } = useTranslation('main')
  const c = classNames.bind(style)
  const cf = classNames.bind(formStyle)

  // eslint-disable-next-line no-unused-vars
  const [layoutContext, setLayoutContext] = useContext(LayoutContext)
  const [sendStatus, setSendStatus] = useState('')
  const formElem = useRef()
  const nameElem = useRef()
  const emailElem = useRef()
  const messageElem = useRef()

  const { user, account } = useUser()
  const emails = user?.Contacts.filter(c => c.Type === 'Email') || []
  const email = emails.find(c => c.IsDefault)?.Value || emails[0]?.Value || ''

  const handleSupportSubmit = e => {
    e.preventDefault()
    formElem.current.removeAttribute('novalidate')
    if (!formElem.current.reportValidity()) {
      return
    }

    event('conversion', 'XJAiCLvj250ZEOLP0NID')

    setSendStatus('sending')

    window.fetch('/api/contact', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        name: nameElem.current.value.trim(),
        email: emailElem.current.value.trim(),
        message: messageElem.current.value.trim(),
        username: user?.UserName,
        account: account?.AccountId,
        source: `stargrams.app${window.location.pathname}`
      })
    }).then(res => {
      if (res.status !== 200) {
        throw new Error('API not available')
      }
      setLayoutContext({ success: t('support-form-sent') })
      setSendStatus('sent')

      formElem.current.setAttribute('novalidate', true)
      formElem.current.reset()
    }).catch(e => {
      setLayoutContext({ message: t('support-form-error') })
      setSendStatus('error')
    })
  }

  return (
    <>
      <Head>
        <title>{t('contact-pagetitle')}</title>
        <meta property='og:title' key='og:title' content={t('contact-ogtitle')} />
        <meta property='og:site_name' key='og:site_name' content={t('contact-sitename')} />
        <meta name='title' key='title' content={t('contact-ogtitle')} />
      </Head>
      <Header showLogo />
      <div className={c('content')}>
        <div className={c('hero')}>
          <Image src='/images/contact_photo.jpg' layout='fill' alt='Photo of the Silver Bullion Shop at Millenia Walk' />
        </div>
        <div className={c('inner')}>
          <div className={c('split')}>
            <div className={c('column')}>
              <div>
                <h3>{t('contact-online-title')}</h3>
                <p><b>{t('contact-online-body-1')}</b></p>
                <p>
                  {t('contact-online-body-2')}<br />
                  {t('contact-online-body-3')} <a href='tel:+6561003040'>+65 6100 3040</a>.<br />
                  {t('contact-online-body-4')} <a href='mailto:sales@silverbullion.com.sg'>sales@silverbullion.com.sg</a><br />
                  <br />
                  {t('contact-online-body-5')}<br />
                  <a href='https://www.facebook.com/silverbullionsg' target='_blank' rel='noopener noreferrer'>Facebook</a> {t('contact-online-body-or')}  <a href='https://www.instagram.com/silverbullionsg/' target='_blank' rel='noopener noreferrer'>Instagram</a>.
                </p>
              </div>
              <div>
                <h3>{t('contact-inperson-title')}</h3>
                <p>
                  <b>Silver Bullion Millenia Walk</b><br />
                  9 Raffles Boulevard #01-108<br />
                  Singapore 039596<br />
                  <br />
                  <b>{t('contact-operatinghours-header')}</b><br />
                  {t('contact-operatinghours-time')}
                </p>
              </div>
            </div>
            {/* <div className={c('promotion')}>
              {t('banner-mission-1')}<br />
              {t('banner-mission-2')}<br />
              <br />
              <br />
              <Link href='/signup'>
                <button className='goldenshimmer' title={t('banner-signup-button-title')}>{t('banner-signup-button')}</button>
              </Link>
              <span className={c('termsnote')}>{t('banner-signup-subtext')}</span>
            </div> */}
            <form noValidate ref={formElem} id='supportform' onSubmit={handleSupportSubmit}>
              <h3>{t('support-form-title')}</h3>
              <p>{t('support-form-body')}</p>
              <div className={cf('inputfield')}>
                <label htmlFor='support_name'>{t('support-name-label')}</label>
                <input type='text' key={user ? user.FirstName + ' ' + user.LastName : ''} disabled={!!user} defaultValue={user ? user.FirstName + ' ' + user.LastName : ''} ref={nameElem} id='support_name' autoComplete='name' required minLength={2} placeholder={t('support-name-placeholder')} onChange={e => { e.target.setCustomValidity('') }} />
              </div>
              <div className={cf('inputfield')}>
                <label htmlFor='support_email'>{t('support-email-label')}</label>
                <input type='email' key={email} defaultValue={email} disabled={!!email} ref={emailElem} id='support_email' autoComplete='email' required placeholder={t('support-email-placeholder')} onChange={e => { e.target.setCustomValidity('') }} />
              </div>
              <div className={cf('inputfield')}>
                <label htmlFor='support_message'>{t('support-message-label')}</label>
                <textarea ref={messageElem} id='support_email' rows={5} required placeholder={t('support-message-placeholder')} onChange={e => { e.target.setCustomValidity('') }} />
              </div>
              <button type='submit' disabled={sendStatus === 'sending'}>{sendStatus !== 'sending' ? t('support-sendmessage-button') : <Loading />}</button>
            </form>
          </div>
        </div>
      </div>
      <Cards />
      <Footer />
    </>
  )
}

Contact.getLayout = getLayout


    export async function getStaticProps(ctx) {
        
        
        return {
          
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/sg/contact',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  